module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-59.a43d3ba6.svg";